import { type FunctionalComponent, h } from '@stencil/core';
import type { labelProviderInterface } from '../../../../../LabelProviderInterface';

export interface IFacetB2cViewButton {
  handleViewBtnClicked: Function;
  showAllFacets?: boolean;
  labelProvider: labelProviderInterface;
}

export const FacetB2cViewButton: FunctionalComponent<IFacetB2cViewButton> = (
  props,
) => {
    const {
      handleViewBtnClicked,
      showAllFacets,
      labelProvider,
    } = props;

    return <div class="facets-view-button">
      <ps-button
        isRightBorderSm={true}
        appearance={'light'}
        ctaText={
          showAllFacets
            ? labelProvider('filters.view-less-filters', 'View less filters')
            : labelProvider('filters.view-more-filters', 'View more filters')
        }
        size="small"
        style={{ width: '100%', cursor: 'pointer', fontFamily: 'Usual, Helvetica, Arial, sans-serif' }}
        onClick={handleViewBtnClicked}
      />
    </div>;
};
